export default __webpack_public_path__ + "static/media/pantry1-afterG-480w.6b762426.png";